import get from "lodash/get";
import moment from "moment";

export const getDateFormatted = (rowProps, statsForm) => {
  var timeRange = get(statsForm, "timeRange", "allTime");
  switch (timeRange) {
    case "allTime":
      return getDateFormattedForMonthRow(rowProps.original);
    case "year":
      return getDateFormattedForMonthRow(rowProps.original);
    case "month":
      return getDateFormattedForDateAndHourRow(rowProps.original);
    default:
      return getDateFormattedForDateAndHourRow(rowProps.original);
  }
};

export const getDateFormattedForMonthRow = row => {
  var startDate = moment.unix(row.date).format("M/DD");
  var endDate = "Now";
  if (row.nextDate) {
    endDate = moment.unix(row.nextDate).format("M/DD");
  }
  return `${startDate} - ${endDate}`;
};

export const getDateFormattedForDateAndHourRow = row => {
  var startDate = moment.unix(row.date).format("MM/DD h:mm a");
  var endDate = "Now";
  if (row.nextDate) {
    endDate = moment.unix(row.nextDate).format("MM/DD h:mm a");
  }
  return `${startDate} - ${endDate}`;
};

export const getData = data => {
  return data.map(({ date, count }, index) => {
    var record = {
      date,
      count,
    };
    if (index + 1 < data.length) {
      record.nextDate = data[index + 1].date;
    }
    return record;
  });
};
